export default Object.freeze({
  Manual: 0,
  Git: 1,
  Zip: 2,
});
